import axios from 'axios';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { setLoggedIn, setMandateData, setOtpTriggered, setShowLanguage } from './MandateSlice';
import cholaLogo from '../Images/Cholamandalam_logo.svg'
import Lang from '../Images/lang.svg'
import Loader from './Loader';
import error from '../Images/Error.svg'

function LoanInfo() {
    const { mandateData, mandateID, partner } = useSelector((state) => state.mandateInfo);
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false)
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [checked, setChecked] = useState(false)
    const [showErr, setShowErr] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [showTCModal, setShowTCModal] = useState(false)
    const mandateId = mandateID ? mandateID : sessionStorage.getItem("id")
    const handleChange = () => {
        setShowErr(false)
        setChecked(!checked);
    };
    useEffect(() => {
        if (mandateId) {
            axios({
                url: process.env.REACT_APP_RESPONSE,
                method: 'post',
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': 'Bearer ' + process.env.REACT_APP_API_KEY
                },
                data: { 'unique_id': mandateId }
            }).then((res) => {
                setLoader(false); res ? dispatch(setMandateData(res?.data)) : dispatch(setMandateData())
            }).catch((e) => {
                setLoader(false)
                setShowErr(e?.message)
            });
        }
    }, [mandateId])

    const proceedDetails = () => {
        // if (mandateData?.nachStatus) {
        //     setShowModal(true)
        // }
        // else {
            if (checked) {
                sessionStorage.removeItem("partner");
                navigate('/payment')
            }
            else {
                setShowErr('Please read the Terms and Conditions, and then click on proceed')
            }
        // }
    }
    const logout = () => {
        dispatch(setOtpTriggered(false))
        dispatch(setLoggedIn(false))
        navigate('/login')
    }
    // const showModall = () =>{
    //     console.log("werks")
    // }
    return (
        <>
            {loader && <Loader />}
            {/* // <div class="Banner-sm">
        //     <div class="container Payment-way-page">
        //         <div class="row">
        //             <div class="col-12 ps-4 pe-4">
        //                 <div class="Bcrumb">
        //                 </div>
        //             </div>
        //             <div class="col-12 col-12 ps-4 pe-4 mt-4 mb-4">
        //                 <h5 class="text-primary">Loan Account Info</h5>
        //                 <div class="card mb-3">
        //                     <div class="card-body">
        //                         <h6 class="card-title text-primary fw-semibold mb-3">Customer Info</h6>
        //                         <div class="row ViewData">
        //                             <div class="col-12">
        //                                 <p><label>Customer Name</label><span>{mandateData?.Name}</span></p>
        //                             </div>
        //                             <div class="col-12">
        //                                 <p><label>Application ID</label><span>{mandateData?.lead_id}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p class="mb-0"><label>Loan Amount</label><span>₹ {mandateData?.Loan_Amount}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p class="mb-0"><label>Mobile No.</label><span>+91 {mandateData?.Phone}</span></p>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //                 <div class="card mb-3">
        //                     <div class="card-body">
        //                         <h6 class="card-title text-primary fw-semibold mb-3">Bank Information</h6>
        //                         <div class="row ViewData">
        //                             <div class="col-12">
        //                                 <p><label>Bank Name</label><span>{mandateData?.Bank_Name}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p><label>Account Number</label><span>{mandateData?.Account_number}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p><label>Account Holder Name</label><span>{mandateData?.Name}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p class="mb-0"><label>Account Type</label><span>{mandateData?.Account_type}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p class="mb-0"><label>IFSC Code</label><span>{mandateData?.Branch_Code}</span></p>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //                 <div class="card mb-3">
        //                     <div class="card-body">
        //                         <h6 class="card-title text-primary fw-semibold mb-3">Mandate Information</h6>
        //                         <div class="row ViewData">
        //                             <div class="col-6">
        //                                 <p><label>EMI Amount</label><span>₹{mandateData?.Collection_Amount}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p><label>Mandate Amount</label><span>₹{mandateData?.Collection_Amount}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p><label>Frequency</label><span>{mandateData?.Frequency}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p><label>First Collection Date</label><span>{mandateData?.First_Collection_Date}</span></p>
        //                             </div>
        //                             <div class="col-6">
        //                                 <p class="mb-0"><label>Last Collection Date</label><span>{mandateData?.Last_Collection_Date}</span></p>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //                 <div class="form-check mb-3">
        //                     <input class="form-check-input" type="checkbox" checked={checked} onChange={handleChange} value="" id="flexCheckDefault" />
        //                     <label class="form-check-label" for="flexCheckDefault">
        //                         I agree with the <a href="#" class="fw-medium">Terms &amp; Conditions</a>
        //                     </label>
        //                 </div>
                        // {showErr && <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        //     {showErr}
                        //     <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">x</button>
                        // </div>}
        //                 <div class="col-12">
        //                     <button class="btn Proceed_btn w-100" type="button" onClick={() => { proceedDetails() }}>Proceed</button>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div> */}
            <div class="container in-spacer">
                <div class="row">
                    <div class="col-12">
                        <h5 class="text-primary mb-3">Customer Loan & Mandate Summary Preview</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-sm-6">
                        <div class="card mb-3">
                            <div class="card-body">
                                <h6 class="card-title text-primary fw-semibold mb-3">Customer Info</h6>
                                <div class="row ViewData">
                                    <div class="col-lg-6 col-sm-12">
                                        <p><label>Customer Name</label><span>{mandateData?.Name}</span></p>
                                    </div>
                                    <div class="col-lg-6 col-sm-12">
                                        <p><label>Agreement Number</label><span>{mandateData?.lead_id}</span></p>
                                    </div>
                                    <div class="col-lg-6 col-sm-12">
                                        <p><label>LOS ID</label><span>{mandateData?.los_id}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p class="mb-0"><label>Loan Amount</label><span><span class="inr">₹</span> {mandateData?.Loan_Amount}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p class="mb-0"><label>Tenure</label><span>{mandateData?.tenure}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p class="mb-0"><label>Mobile No.</label><span>+91 {mandateData?.Phone}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-body">
                                <h6 class="card-title text-primary fw-semibold mb-3">Bank Information</h6>
                                <div class="row ViewData">
                                    <div class="col-lg-6 col-sm-12">
                                        <p><label>Bank Name</label><span>{mandateData?.Bank_Name}</span></p>
                                    </div>
                                    <div class="col-lg-6 col-sm-12">
                                        <p><label>Account Number</label><span>{mandateData?.Account_number}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p><label>Account Holder Name</label><span>{mandateData?.Name}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p class="mb-0"><label>Account Type</label><span>{mandateData?.Account_type}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p class="mb-0"><label>IFSC Code</label><span>{mandateData?.Branch_Code}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-6">
                        <div class="card mb-3">
                            <div class="card-body">
                                <h6 class="card-title text-primary fw-semibold mb-3">Mandate Information</h6>
                                <div class="row ViewData">
                                    {/* <div class="col-6">
                                    <p><label>EMI Amount</label><span>₹5,000</span></p>
                                </div> */}
                                    <div class="col-6">
                                        <p><label>Mandate Amount</label><span><span class="inr">₹</span> {mandateData?.Collection_Amount}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p><label>Frequency</label><span>{mandateData?.Frequency}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p><label>First Collection Date</label><span>{mandateData?.First_Collection_Date}</span></p>
                                    </div>
                                    <div class="col-6">
                                        <p class="mb-0"><label>Last Collection Date</label><span>{mandateData?.Last_Collection_Date}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-sm-12 mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" checked={checked} onChange={handleChange} value="" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                I agree with the
                            </label>
                            <a 
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => { setShowTCModal(true) }} 
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                        e.preventDefault();
                                                                                        setShowTCModal(true)
                                                                                    }
                                                                                }}
                                                                                class="fw-medium cursor-pointer"> Terms &amp; Conditions</a>
                        </div>
                    </div>
                    <div class="col-lg-12 col-sm-12 mb-3">
                        {showErr &&
                        <div class="alert alert-danger alert-dismissible fade show" role="alert">
                            <p class="mb-1">{showErr}</p>
                            <button type="button" class="btn-close" data-bs-dismiss="alert" onClick={() => { setShowErr(false) }} aria-label="Close">&#215;</button>
                        </div>
                        }
                    </div>
                    <div class="col-lg-4 col-sm-6 mb-3">
                        <button class="btn Proceed_btn w-100" type="button" onClick={() => { proceedDetails() }}
                        >Proceed</button>
                    </div>
                </div>
                {/* <div class="row">
                <div class="col-12">
                    <nav class="navbar MenuTop fixed-top navbar-expand-lg">
                        <div class="container d-flex">
                            <a class="navbar-brand p-0 me-0">
                                <img src={cholaLogo} alt="Chola Logo" />
                            </a>
                            <ul class="navbar-nav">
                                <li class="nav-item">
                                    <a class="nav-link" onClick={() => { dispatch(setShowLanguage(true)) }}>
                                        <img src={Lang} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div> */}
                <div class="row">
                    <div class="col-12">
                        <nav class="navbar MenuTop fixed-top navbar-expand-lg navstyles">
                            <div class="container">
                                <a class="navbar-brand-sm" href="#">
                                    <img src={cholaLogo} alt="Chola Logo" />
                                </a>
                                <ul class="nav-list">
                                    <li class="nav-item">
                                        {/* <a class="nav-link" href="Language.html">
                                            <img src={Lang} />
                                        </a> */}
                                    </li>
                                    {partner === 'chola-web' && <li>
                                        <a href="#" onClick={logout}>Logout</a>
                                    </li>}
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            {showModal &&
                <>
                    <div class="modal fade show" id="ErrorModal" style={{ display: "block" }} aria-labelledby="ErrorModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg modal-dialog-centered mobOnly">
                            <div class="modal-content">
                                <div class="modal-body mb-4">
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setShowModal(false) }}></button>
                                    <div class="text-center">
                                        <img src={error} class="img-fluid mb-3" />
                                        <div class="col-md-8 offset-md-2">
                                            <p class="fw-semibold mb-4">{mandateData?.Message}</p>
                                            {/* Please contact your nearest branch for more details
                                                on physical mandate registration.</p> */}
                                        </div>
                                        <button type="button" class="btn Proceed_btn w-25"
                                            onClick={() => { setShowModal(false) }}>Okay</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-backdrop fade show"></div>
                </>}
            {showTCModal &&
                <>
                    {/* <div class="modal fade show" id="ErrorModal" style={{ display: "block" }} aria-labelledby="ErrorModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg modal-dialog-centered mobOnly">
                            <div class="modal-content">
                                <div class="modal-body mb-4">
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setShowTCModal(false) }}></button>
                                    <div class="text-center">
                                        <div class="col-md-8 offset-md-2">
                                            <p class="fw-semibold mb-4">Terms & Conditions</p>
                                        </div>
                                        <button type="button" class="btn Proceed_btn w-25"
                                            onClick={() => { setShowTCModal(false) }}>Okay</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div class="modal fade show" id="ErrorModal" style={{ display: "block" }} aria-labelledby="TermsLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable mobOnly">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h1 class="modal-title fs-5" id="TermsLabel">Terms &amp;
                                        Conditions</h1>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" onClick={() => { setShowTCModal(false) }} aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <p>I/We hereby declare that the particulars given herein are correct and complete in all respects. If the
                                        transaction is delayed or not effected at all for reasons of incomplete or incorrect information or due to
                                        system issues, I/We would not hold the CIFCL or your service provider / participating banks responsible. I/We
                                        authorise CIFCL to use the above-mentioned contact details for the purpose of processing direct debit/ACH
                                        mandate. </p>
                                    <p> I/ We hereby express my unconditional consent to debit installments or loan outstanding through
                                        participation in Automated Clearing House (ACH) including E-NACH/direct debit until my/our written request for
                                        cancellation of the same irrespective of expiry or termination of loan tenure.</p>
                                    <p> In the instance of dishonour of ACH/direct debit, I/We authorize CIFCL to re-present the ACH mandate/direct
                                        debit instructions in my/our bank account until realization of said amounts.</p>
                                    <p> I/We understand and agree that the submission of this form does not mean that the request will be processed
                                        and I/we understand that it is subject to multi-layer verification by my/our bank, NPCI and the destination
                                        bank and on successful verification the auto-deduction process will be initiated.</p>
                                    <p> I/We also understand and agree that the CIFCL reserves the right to demand any alternative payment option. </p>
                                    <p> I/We have read and understood all the Terms & Conditions mentioned herein above.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-backdrop fade show"></div>
                </>}
        </>
    )
}

export default LoanInfo